import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMessage('Invalid verification link.'); return; }

    api.get(`/api/auth/verify-email?token=${token}`)
      .then((res) => { setStatus('success'); setMessage(res.data.message); })
      .catch((err) => { setStatus('error'); setMessage(err.response?.data?.message || 'Verification failed.'); });
  }, [searchParams]);

  return (
    <Box sx={{ minHeight: 'calc(100vh - 260px)', display: 'grid', placeItems: 'center', px: 2, py: { xs: 5, md: 7 }, bgcolor: '#f5f7fb' }}>
      <Paper variant="outlined" sx={{ p: 4, borderRadius: 2, boxShadow: '0 20px 50px rgba(7,24,45,0.08)', width: '100%', maxWidth: 480, borderColor: 'rgba(7,24,45,0.08)', textAlign: 'center' }}>
        {status === 'loading' && (
          <Stack spacing={2} alignItems="center">
            <CircularProgress />
            <Typography variant="body2" color="text.secondary">Verifying your email…</Typography>
          </Stack>
        )}
        {status === 'success' && (
          <Stack spacing={2} alignItems="center">
            <Typography variant="h5" fontWeight={700}>Email verified ✓</Typography>
            <Typography variant="body2" color="text.secondary">{message}</Typography>
            <Button component={RouterLink} to="/login" variant="contained" color="secondary">
              Go to login
            </Button>
          </Stack>
        )}
        {status === 'error' && (
          <Stack spacing={2} alignItems="center">
            <Typography variant="h5" fontWeight={700}>Verification failed</Typography>
            <Typography variant="body2" color="error">{message}</Typography>
            <Button component={RouterLink} to="/login" variant="outlined">
              Back to login
            </Button>
          </Stack>
        )}
      </Paper>
    </Box>
  );
};

export default VerifyEmail;
